<template>
	<div class="layout-footer" >
        <div class="p-grid">
            <div class="p-col-12 p-md-6  p-lg-3">
                <span class="logo">伴生质子束用户系统</span>
                <p>版权所有 ©2021 散裂中子源科学中心</p>
            </div>
            <div class="p-col-12 p-md-6 p-lg-3">
                <span>相关链接</span>
                <div class="p-grid">
                    <ul class="links">
                        <li> <a href="https://user.csns.ihep.ac.cn/">CSNS用户服务系统</a></li>
                        <li> <a href="https://backn.csns.ihep.ac.cn">Back-n用户系统</a></li>
                        <li> <a href="https://login.csns.ihep.ac.cn">CSNS统一认证系统</a></li>
                    </ul>
                </div>

            </div>
        </div>
	</div>
</template>

<script>
	export default {
		name: "AppFooter"
	}
</script>

<style scoped>

</style>
